import React, { useCallback, useContext, useState } from "react";
import Switch from "react-bootstrap/esm/Switch";
import { Route, useRouteMatch } from "react-router";
import CartContext from "../../cartcontext/CartContext";

import ToastContext from "../../toastcontext/ToastContext";
import Cart from "./Cart";
import Checkout from "./checkout/Checkout";
import ModalTemplate from "./modal/ModalTemplate";

import NavBar from "./NavBar";
import Order from "./Order";

import tz from "moment-timezone";
import moment from "moment";
import "moment/locale/ne";
import TimeContext from "../../timecontext/TimeContext";

function OrderOnline() {
  const { url, path } = useRouteMatch();

  const [isCart, setIsCart] = useState(false);
  const [modal, setModal] = useState({ toggle: false, menu: {} });

  const { cartState, dispatchCart, IsOpen, getQty } = useContext(CartContext);
  const { setToast } = useContext(ToastContext);

  const { isStoreClosed } = useContext(TimeContext);

  const toggleModal = useCallback(
    (menu) => {
      //check store open or not
      if (!isStoreClosed()) {
        setToast({
          show: true,
          title: "Warning",
          description:
            "Store is closed. Please order between 10:00 am - 7:30 pm GMT+5:45 time",
        });
        return;
      }

      if (getQty() > 20) {
        setToast({
          show: true,
          title: "Warning",
          description:
            " Max Order 20 Qty. Please call +977-980-8011299 for catering service. Thank you",
        });
      } else {
        modal.toggle
          ? setModal({ toggle: false, menu: menu })
          : setModal({ toggle: true, menu: menu });
      }
    },
    [modal.toggle]
  );

  const toggleCart = useCallback(() => {
    isCart ? setIsCart(false) : setIsCart(true);
  }, [isCart]);

  const isModal = () => {
    return modal ? <ModalTemplate modal={modal} setModal={setModal} /> : "";
  };

  return (
    <div>
      <NavBar toggleCart={toggleCart} />
      <div style={{ paddingTop: "70px" }}>
        <div className="row no-gutters">
          <div className="col-md-12 col-lg-12 col-12 py-4">
            <Switch className="m-0 p-0">
              <Route
                path={`${path}/:value`}
                render={(value) => {
                  const param = value.match.params.value;
                  switch (param) {
                    case "online":
                      return <Order toggleModal={toggleModal} />;
                    case "checkout":
                      return <Checkout toggleModal={toggleModal} />;

                    default:
                      return <Order toggleModal={toggleModal} />;
                  }
                }}
              ></Route>
            </Switch>
          </div>
          {isCart ? <Cart toggleCart={toggleCart} /> : ""}
        </div>
      </div>
      {isModal()}
    </div>
  );
}

export default OrderOnline;
